export * from './specimen-transaction.service';